var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66361 0.572201C5.03015 -0.172022 6.09126 -0.172024 6.4578 0.572199L7.2712 2.22371C7.4167 2.51914 7.69833 2.72399 8.02421 2.77145L9.8464 3.03677C10.666 3.15611 10.9935 4.16298 10.4011 4.7417L9.07989 6.03219C8.84478 6.26183 8.73752 6.59233 8.79297 6.91626L9.1045 8.73635C9.24437 9.55354 8.38624 10.1762 7.65274 9.7898L6.0268 8.93323C5.73507 8.77954 5.38634 8.77954 5.09461 8.93323L3.46867 9.7898C2.73517 10.1762 1.87704 9.55354 2.01691 8.73636L2.32844 6.91626C2.38389 6.59233 2.27663 6.26183 2.04152 6.03219L0.720352 4.7417C0.127869 4.16299 0.455431 3.15611 1.27501 3.03677L3.09721 2.77145C3.42309 2.72399 3.70471 2.51914 3.85021 2.22371L4.66361 0.572201Z",
    fill: "url(#paint0_linear_1298_37776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_37776",
    x1: 5.56071,
    y1: -1.24927,
    x2: 5.56071,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC42C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B402"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.14ebbb99b2801295859be5e8a26ed188.svg";
export { ForwardRef as ReactComponent };